import {
  IFboBankAccountImportPayload,
  IFboBankAccountCreatePayload,
  IFboBankAccountUpdatePayload,
} from '@common/interfaces/fboBankAccount'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'fboBankAccounts'

export const [
  LIST_FBO_BANK_ACCOUNTS_REQUEST,
  LIST_FBO_BANK_ACCOUNTS_SUCCESS,
  LIST_FBO_BANK_ACCOUNTS_FAILURE,
] = createRequestTypes(prefix, 'LIST_FBO_BANK_ACCOUNTS')

export const [
  GET_FBO_BANK_ACCOUNTS_SUMMARY_REQUEST,
  GET_FBO_BANK_ACCOUNTS_SUMMARY_SUCCESS,
  GET_FBO_BANK_ACCOUNTS_SUMMARY_FAILURE,
] = createRequestTypes(prefix, 'GET_FBO_BANK_ACCOUNTS_SUMMARY')

export const [
  CREATE_FBO_BANK_ACCOUNT_REQUEST,
  CREATE_FBO_BANK_ACCOUNT_SUCCESS,
  CREATE_FBO_BANK_ACCOUNT_FAILURE,
] = createRequestTypes(prefix, 'CREATE_FBO_BANK_ACCOUNT')

export const [
  IMPORT_FBO_BANK_ACCOUNTS_REQUEST,
  IMPORT_FBO_BANK_ACCOUNTS_SUCCESS,
  IMPORT_FBO_BANK_ACCOUNTS_FAILURE,
] = createRequestTypes(prefix, 'IMPORT_FBO_BANK_ACCOUNTS')

export const [
  UPDATE_FBO_BANK_ACCOUNT_REQUEST,
  UPDATE_FBO_BANK_ACCOUNT_SUCCESS,
  UPDATE_FBO_BANK_ACCOUNT_FAILURE,
] = createRequestTypes(prefix, 'UPDATE_FBO_BANK_ACCOUNT')

export const listFboBankAccounts = createAction((params?: object) => ({
  type: [
    LIST_FBO_BANK_ACCOUNTS_REQUEST,
    LIST_FBO_BANK_ACCOUNTS_SUCCESS,
    LIST_FBO_BANK_ACCOUNTS_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.fboBankAccount.list(params),
  params,
}))

export const getFboBankAccountsSummary = createAction(() => ({
  type: [
    GET_FBO_BANK_ACCOUNTS_SUMMARY_REQUEST,
    GET_FBO_BANK_ACCOUNTS_SUMMARY_SUCCESS,
    GET_FBO_BANK_ACCOUNTS_SUMMARY_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.fboBankAccount.summary(),
}))

export const createFboBankAccount = createAction((data: IFboBankAccountCreatePayload) => ({
  type: [
    CREATE_FBO_BANK_ACCOUNT_REQUEST,
    CREATE_FBO_BANK_ACCOUNT_SUCCESS,
    CREATE_FBO_BANK_ACCOUNT_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.fboBankAccount.create(data),
}))

export const importFboBankAccounts = createAction((data: IFboBankAccountImportPayload) => ({
  type: [
    IMPORT_FBO_BANK_ACCOUNTS_REQUEST,
    IMPORT_FBO_BANK_ACCOUNTS_SUCCESS,
    IMPORT_FBO_BANK_ACCOUNTS_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.fboBankAccount.bulkImport(data),
}))

export const updateFboBankAccount = createAction(
  (id: string, data: IFboBankAccountUpdatePayload) => ({
    type: [
      UPDATE_FBO_BANK_ACCOUNT_REQUEST,
      UPDATE_FBO_BANK_ACCOUNT_SUCCESS,
      UPDATE_FBO_BANK_ACCOUNT_FAILURE,
    ] as [string, string, string],
    promise: (api: IApi) => api.fboBankAccount.update(id, data),
  }),
)
